//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';



export default {
    state: {
        gstLoad: [],
        searchRequest: null,
      },

      mutations: {
        updateGSTLoad(state, list) {
          state.gstLoad = list;
        },
        updateSearchGSTLoadRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async gstLoad({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));

          // if (requestToSend.chzStartDate.endDate) {
          //   requestToSend.chzStartDate.endDate = moment(requestToSend.chzStartDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.chzStartDate.startDate && !requestToSend.chzStartDate.endDate) {
          //   requestToSend.chzStartDate.endDate = moment(requestToSend.chzStartDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }


          // if (requestToSend.chzEndDate.endDate) {
          //   requestToSend.chzEndDate.endDate = moment(requestToSend.chzEndDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.chzEndDate.startDate && !requestToSend.chzEndDate.endDate) {
          //   requestToSend.chzEndDate.endDate = moment(requestToSend.chzEndDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }


          // if (requestToSend.deliveryStartDate.endDate) {
          //   requestToSend.deliveryStartDate.endDate = moment(requestToSend.deliveryStartDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.deliveryStartDate.startDate && !requestToSend.deliveryStartDate.endDate) {
          //   requestToSend.deliveryStartDate.endDate = moment(requestToSend.deliveryStartDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }


          // if (requestToSend.deliveryEndDate.endDate) {
          //   requestToSend.deliveryEndDate.endDate = moment(requestToSend.deliveryEndDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.deliveryEndDate.startDate && !requestToSend.deliveryEndDate.endDate) {
          //   requestToSend.deliveryEndDate.endDate = moment(requestToSend.deliveryEndDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }


          if (requestToSend.confirmDate.endDate) {
            requestToSend.confirmDate.endDate = moment(requestToSend.confirmDate.endDate)
              .endOf('d')
              .toDate();
          }
        
          if (requestToSend.confirmDate.startDate && !requestToSend.confirmDate.endDate) {
            requestToSend.confirmDate.endDate = moment(requestToSend.confirmDate.startDate)
              .endOf('d')
              .toDate();
          }


          if (requestToSend.changeDate.endDate) {
            requestToSend.changeDate.endDate = moment(requestToSend.changeDate.endDate)
              .endOf('d')
              .toDate();
          }
        
          if (requestToSend.changeDate.startDate && !requestToSend.changeDate.endDate) {
            requestToSend.changeDate.endDate = moment(requestToSend.changeDate.startDate)
              .endOf('d')
              .toDate();
          }


          if (requestToSend.chzStartDate.startDate)
          {
            requestToSend.chzStartDate.startDate = dateFormat.getLocalDate(requestToSend.chzStartDate.startDate);
          }

          if (requestToSend.chzStartDate.endDate)
          {
            requestToSend.chzStartDate.endDate = dateFormat.getLocalDateEnd(requestToSend.chzStartDate.endDate);
          }
          else
          {
            requestToSend.chzStartDate.endDate = dateFormat.getLocalDateEnd(requestToSend.chzStartDate.startDate);
          }


          if (requestToSend.chzEndDate.startDate)
          {
            requestToSend.chzEndDate.startDate = dateFormat.getLocalDate(requestToSend.chzEndDate.startDate);
          }

          if (requestToSend.chzEndDate.endDate)
          {
            requestToSend.chzEndDate.endDate = dateFormat.getLocalDateEnd(requestToSend.chzEndDate.endDate);
          }
          else
          {
            requestToSend.chzEndDate.endDate = dateFormat.getLocalDateEnd(requestToSend.chzEndDate.startDate);
          }



          if (requestToSend.deliveryStartDate.startDate)
          {
            requestToSend.deliveryStartDate.startDate = dateFormat.getLocalDate(requestToSend.deliveryStartDate.startDate);
          }

          if (requestToSend.deliveryStartDate.endDate)
          {
            requestToSend.deliveryStartDate.endDate = dateFormat.getLocalDateEnd(requestToSend.deliveryStartDate.endDate);
          }
          else
          {
            requestToSend.deliveryStartDate.endDate = dateFormat.getLocalDateEnd(requestToSend.deliveryStartDate.startDate);
          }



          if (requestToSend.deliveryEndDate.startDate)
          {
            requestToSend.deliveryEndDate.startDate = dateFormat.getLocalDate(requestToSend.deliveryEndDate.startDate);
          }

          if (requestToSend.deliveryEndDate.endDate)
          {
            requestToSend.deliveryEndDate.endDate = dateFormat.getLocalDateEnd(requestToSend.deliveryEndDate.endDate);
          }
          else
          {
            requestToSend.deliveryEndDate.endDate = dateFormat.getLocalDateEnd(requestToSend.deliveryEndDate.startDate);
          }




          var reqStart = null;
          var reqEnd = null;

          if (requestToSend.chzStartDate.startDate != null){
            reqStart = requestToSend.chzStartDate.startDate;
            reqEnd = requestToSend.chzStartDate.endDate;
          }


          if (requestToSend.chzEndDate.startDate != null)
          {
            if (reqStart == null)
            {
              reqStart = requestToSend.chzEndDate.startDate;
              reqEnd = requestToSend.chzEndDate.endDate;
            }
            else
            {
              if (requestToSend.chzEndDate.startDate < reqStart )
              {
                reqStart = requestToSend.chzEndDate.startDate
              }
              if (requestToSend.chzEndDate.endDate > reqEnd )
              {
                reqEnd = requestToSend.chzEndDate.endDate
              }
            }
          }

          if (requestToSend.deliveryStartDate.startDate != null)
          {
            if (reqStart == null)
            {
              reqStart = requestToSend.deliveryStartDate.startDate;
              reqEnd = requestToSend.deliveryStartDate.endDate;
            }
            else
            {
              if (requestToSend.deliveryStartDate.startDate < reqStart)
              {
                reqStart = requestToSend.deliveryStartDate.startDate
              }

              if (requestToSend.deliveryStartDate.endDate > reqEnd )
              {
                reqEnd = requestToSend.deliveryStartDate.endDate
              }


            }
            
          }


          if (requestToSend.deliveryEndDate.startDate != null)
          {
            if (reqStart == null)
            {
              reqStart = requestToSend.deliveryEndDate.startDate;
              reqEnd = requestToSend.deliveryEndDate.endDate;
            }
            else
            {
              if (requestToSend.deliveryEndDate.startDate < reqStart)
              {
                reqStart = requestToSend.deliveryEndDate.startDate
              }

              if (requestToSend.deliveryEndDate.endDate > reqEnd )
              {
                reqEnd = requestToSend.deliveryEndDate.endDate
              }


            }
            
          }

          if (requestToSend.confirmDate.startDate != null)
          {
            if (reqStart == null)
            {
              reqStart = requestToSend.confirmDate.startDate;
              reqEnd = requestToSend.confirmDate.endDate;
            }
            else
            {
              if (requestToSend.confirmDate.startDate < reqStart)
              {
                reqStart = requestToSend.confirmDate.startDate
              }

              if (requestToSend.confirmDate.endDate > reqEnd )
              {
                reqEnd = requestToSend.confirmDate.endDate
              }


            }
           
          }


          if (requestToSend.changeDate.startDate != null)
          {
            if (reqStart == null)
            {
              reqStart = requestToSend.changeDate.startDate;
              reqEnd = requestToSend.changeDate.endDate;
            }
            else
            {
              if (requestToSend.changeDate.startDate < reqStart)
              {
                reqStart = requestToSend.changeDate.startDate
              }

              if (requestToSend.changeDate.endDate > reqEnd )
              {
                reqEnd = requestToSend.changeDate.endDate
              }
            }
            
          }

            console.log(`req start is ${reqStart}`)
            console.log(`req end is ${reqEnd}`)
            console.log(requestToSend);
            requestToSend.createdAt.startDate = moment(reqStart).subtract(2, 'months');
            requestToSend.createdAt.endDate = moment(reqEnd).add(2, 'months');

            const st = performance.now();
            //const result = await api.post('/api/w/gstConfirm/WebSearchConfirmLoads', requestToSend);
            const result = await newAPIPost('/api/w/gstConfirm/WebSearchConfirmLoads', requestToSend);
          
            commit('updateSearchGSTLoadRequest', fallbackRequest);
            console.log(result);
            return commit('updateGSTLoad', result);
            
                },
      },


      getters: {
        getGSTLoad: state => state.gstLoad,
      },








}